module.exports = __webpack_public_path__ + "img/fi-rr-zoom-out.6d6ac055.svg";